import PropTypes from 'prop-types';
import React from 'react';
import ProcessUtils from 'utils/ProcessUtils';
import ComboBoxHOC from 'components/core/ComboBoxHOC';


/**
 * This form is used when the dimensions on a retreived variable have a mismatch with the dimensions on 
 * the coordinate system they are being mapped to.
 */
export default class DimensionConflictForm extends React.Component {
    static propTypes = {
        process: PropTypes.object,
        coordinateSystemName: PropTypes.string,
        conflicts: PropTypes.object
    };

    constructor(props) {
        super(props);

        // Initialize the resolutions map
        const resolutions = {};
        Object.keys(props.conflicts).forEach(variableName => {
            if (!resolutions[variableName]) {
                resolutions[variableName] = {};
            }
            Object.keys(props.conflicts[variableName]).forEach(dimensionName => {
                resolutions[variableName][dimensionName] = {
                    action: 'add',
                    newDimensionName: props.conflicts[variableName][dimensionName][0]
                };
            });
        });

        this.state = {
            resolutions,
        };
    }

    getResolutions() {
        return this.state.resolutions;
    }

    onRadioClick = (variableName, dimensionName, event) => {
        const action = event.target.value;
        const resolutions = Object.assign({}, this.state.resolutions);
        resolutions[variableName][dimensionName].action = action;
        this.setState({ resolutions });
    };

    onSelectChange = (valueObject) => {     
        const resolutions = Object.assign({}, this.state.resolutions);

        // If value object is null, then the user clicked the X to clear the typed in value.
        // Since we don't allow the user to add a custom value to this select, then we just ingore
        // the change if the value is null.
        if (valueObject) {
            const variableName = valueObject.value.variableName;
            const variableDimensionName = valueObject.value.variableDimensionName;
            const newName = valueObject.value.newName;
            resolutions[variableName][variableDimensionName].newDimensionName = newName;    
        }
        this.setState({ resolutions });
    };

    renderVariableForms = () => {
        const forms = [];

        Object.keys(this.props.conflicts).forEach(variableName => {
            const variable = this.props.process.variable_retrieval.retrieved_variables[variableName];

            Object.keys(this.props.conflicts[variableName]).forEach(variableDimensionName => {
                const onRadioClick = this.onRadioClick.bind(this, variableName, variableDimensionName);
                const groupName = `${variableName}-${variableDimensionName}`;
                const resolutionAction = this.state.resolutions[variableName][variableDimensionName].action;
                const newName = this.state.resolutions[variableName][variableDimensionName].newDimensionName;
                const newNameValue = { value: { variableName, variableDimensionName, newName },
                                       label: newName };
                const newNameOptions = this.props.conflicts[variableName][variableDimensionName].map(newNameChoice => {
                    return { value: { variableName, variableDimensionName, newName: newNameChoice },
                             label: newNameChoice };
                });

                forms.push(
                    <div key={`form-${variableName}-${variableDimensionName}`} className="section">
                        <p>In Variable: <span className="entity-name">{variableName} ({variable.dims.join(', ')})</span></p>
                        <p>Dimension <span className="entity-name">{variableDimensionName}</span>
                         does not match coordinate system dimension <span className="entity-name">{newName}</span></p>
                         <p>How do you want to resolve this conflict?</p>
                        <div style={{ marginBottom: '5px' }}>
                            <input
                                type="radio"
                                name={groupName}
                                value="add"
                                checked={resolutionAction === 'add'}
                                onChange={onRadioClick}
                            />
                            <span className="radio-label">Append dimension ({variableDimensionName}) to the coordinate system.</span>
                        </div>
                        <div>
                            <input type="radio"
                                name={groupName}
                                value="rename"
                                checked={resolutionAction === 'rename'}
                                onChange={onRadioClick}
                            />
                            <span className="radio-label">Rename the variable's dimension to: </span>
                            <ComboBoxHOC
                                classNamePrefix="react-select"
                                value={newNameValue}
                                options={newNameOptions}
                                onChange={this.onSelectChange}
                            />
                        </div>
                    </div>
                );

            });
        });

        return forms;
    };

    render = () => {
        const dims = ProcessUtils.getDimensionNamesAsArray(this.props.process, this.props.coordinateSystemName).join(', ');
        return (
            <div className="handle-existing-variables-modal scrollable rie-scrollable">
                <p className="warning-message">WARNING - Name Mismatch!</p>
                <p> Retrieved variable dimensions don't match those from coordinate system:</p>
                <p><span className="entity-name">{this.props.coordinateSystemName}({dims})</span></p>
                <div className="form">
                    {this.renderVariableForms()}
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/core/forms/DimensionConflictForm.js